import { makeAutoObservable } from "mobx";
import DistantService from "../services/DistantService";

export default class DistantStore {
    status = '';
    avatar = '';

    constructor() {
        makeAutoObservable(this);
    };

    setStatus(val: string) {
        this.status = val;
    };

    setAvatar(val: string) {
        this.avatar = val;
    };

    async createAvatar(avatar: string) {
        try {
            this.setAvatar(avatar)
            await DistantService.createAvatar({avatar})
        } catch (e) {
            console.log(e);
        };
    };

};